import { TAG_TYPE } from './constants';
import Tag from './Tag';

export { TAG_TYPE };
export default Tag;
